angular.module('qkr').factory('adminService', ($http, appConfig) => ({

        sendEmailVcode(id) {
        	return $http.get(appConfig.apiUrl + 'registration/sendEmailVerificationCode/' + id)
                .then((promise) => promise.data);
        }

    }));




// WEBPACK FOOTER //
// ./src/services/admin.service.js